export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    ApplicableTicketTypeSource: ['TAAddOnType', 'TATicketUpgradeType'],
    ConnectionEntity: ['Appearance', 'Attendee'],
    MenuItemLinkDynamicZone: [
      'ComponentWebLinksPageLink',
      'ComponentWebLinksSubMenu',
      'ComponentWebLinksUrlLink',
    ],
    NotificationConfig: ['NotificationConfigPubnub'],
    RoomChatConfig: ['RoomChatConfigPubnub'],
    RoomModerationConfig: ['RoomModerationConfigPubnub'],
    RoomPubnubConfig: [
      'RoomChatConfigPubnub',
      'RoomModerationConfigPubnub',
      'RoomQuestionsConfigPubnub',
      'RoomReactionsConfigPubnub',
    ],
    RoomQuestionsConfig: ['RoomQuestionsConfigPubnub'],
    RoomReactionsConfig: ['RoomReactionsConfigPubnub'],
    RoomVideoCallConfig: ['RoomVideoCallConfigVonage'],
    WebPageContentDynamicZone: [
      'ComponentWebElementsAttendeeSearchSidebarFilters',
      'ComponentWebElementsCompanySearchSidebarFilters',
      'ComponentWebElementsFreshchat',
      'ComponentWebElementsHeroSection',
      'ComponentWebElementsScheduleSearchSidebarFilters',
      'ComponentWebElementsShowcaseGrid',
      'ComponentWebLayoutsStoresTicketApplicationsPage',
      'ComponentWebLayoutsStoresTicketSalesPage',
      'ComponentWebLayoutsTicketApplicationsPage',
      'ComponentWebLayoutsTicketSalesPage',
    ],
  },
}
export default result
